import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import * as util from 'notebook/tables/excess/Util';
import {coerceToPrimitive, formatTypedValue} from 'notebook/tables/typed-values/DataTypes';
import {TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';

export function validateNumChars(
  functionName: string,
  numChars?: number
): asserts numChars is number | undefined {
  if (numChars === undefined) {
    return;
  }

  // Given the possibility of floating-point imprecision in JavaScript, we'd have to round both up and down
  // to be safe. This would be inconsistent with Excel, which always rounds down, so we require integer
  // indices to avoid the ambiguity.
  if (!Number.isInteger(numChars)) {
    throw new util.ValueError(`${functionName} number of characters must be an integer`);
  }

  // Logic and errors should match the Excel function:
  // https://support.microsoft.com/en-us/office/right-rightb-functions-240267ee-9afa-4639-a02b-f19e1786cf2f
  if (numChars < 0) {
    throw new util.ValueError(`${functionName} number of characters cannot be negative`);
  }
}

// Used by both LEFT and RIGHT string slicer functions
export default {
  name: '',
  category: FunctionCategory.TEXT,
  params: [
    {
      name: 'string',
      type: ArgType.any,
      description: '',
    },
    {
      name: 'number_of_characters',
      type: ArgType.number,
      optional: true,
      description: '',
    },
  ],

  // TODO: convert to coerce()
  processArgValues(argValues: [TypedValue, TypedValue | null], context?): [string, number?] {
    const [arg1, arg2] = argValues;
    return [
      formatTypedValue(arg1, {}, '', undefined, context),
      arg2 == null ? undefined : (coerceToPrimitive(arg2, {shouldCoerceStringToNumber: true}) as number),
    ];
  },
} satisfies Partial<EvaluablePrimitiveSpreadsheetFunction>;
